<template>
    <div data-testid="business-sectors-filter">
        <h3>{{ $t('search.filters.activity.areas.label') }}</h3>
        <CollapsibleList data-testid-prefix="business-sectors-filter" :min-visible-items="6" :items="businessSectors">
            <template #default="{item: businessSector, visible}">
                <VJoyCheckbox
                    v-show="visible"
                    :checked="isChecked(businessSector.key)"
                    :data-testid="`business-sectors-filter-${businessSector.key}`"
                    :label="`${businessSector.label} (${businessSector.count})`"
                    @update:checked="toggleFilter(businessSector.key)"
                />
            </template>
        </CollapsibleList>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyCheckbox} from '@maltjoy/core-vue';
    import CollapsibleList from '~/components/common/CollapsibleList.vue';
    import {useFiltersStore} from '../stores/filters.store';

    const filtersStore = useFiltersStore();
    const {availableSearchFilters} = storeToRefs(filtersStore);

    const businessSectors = computed(() => availableSearchFilters.value?.businessSectors ?? []);

    function isChecked(businessSectorFilter: string) {
        return filtersStore.isFilterChecked('businessSectors', businessSectorFilter);
    }

    function toggleFilter(businessSectorFilter: string) {
        filtersStore.toggleFilter('businessSectors', businessSectorFilter);
    }
</script>
